import {
  debounce,
  viewportObserver,
  t,
} from '@nova/utils'

class NovaFiltersWrapper extends HTMLElement {
  constructor() {
    super()
    this.viewport = viewportObserver.currentViewport
    viewportObserver.addListener(this._handleViewportChange)
    this.filterData = []
    this.debouncedOnSubmit = debounce(this.onSubmitHandler, 500)
  }

  connectedCallback() {
    this.$submitInputs = this.querySelectorAll('.js-filter-submit')
    this.$sortInput = this.querySelector('.js-sort-input')
    this.$filtersTrigger = this.querySelector('.js-filters-trigger')
    this.$filtersDrawer = this.querySelector('.js-collection-filters')
    this.$closeButton = this.querySelector('.js-close')
    this.$filterCheckboxes = this.querySelectorAll('.js-filter-checkbox')
    this.$summaryFilterCountEl = document.querySelectorAll('.js-filter-count')
    this.$clearAll = this.querySelector('.js-collection-filter-clear')
    this.$filtersBar = this.querySelector('.js-filters-bar')
    this.$totalProductsCountSurfix = this.querySelector('.js-total-products-count-surfix')
    this.$blockDetails = this.querySelectorAll('.collection-filters__block sl-details')
    this.$totalFilterCountMarkers = document.querySelectorAll(
      '[data-total-filter-count]',
    )
    this.$viewProductsCountMarkers = document.querySelectorAll(
      '[data-view-products-count]',
    )
    this.$totalProductsCountMarkers = document.querySelectorAll(
      '[data-total-products-count]',
    )

    this.bindActiveFacetButtonEvents()
    window.addEventListener('popstate', this._onHistoryChange)

    for (const $element of this.$submitInputs) {
      $element.addEventListener('click', this.debouncedOnSubmit)
    }
    this.$sortInput?.addEventListener('sl-change', this.debouncedOnSubmit)
    this.$closeButton?.addEventListener('click', this._closeFilters)

    for (const $checkbox of this.$filterCheckboxes) {
      $checkbox.addEventListener('sl-change', this._handleCheckboxChange)
    }

    this.$filtersTrigger?.addEventListener('click', () => {
      this.$filtersDrawer?.setAttribute('placement', 'end')
      if (this.viewport === 'desktop' || this.viewport === 'widescreen') {
        this.$filtersDrawer?.setAttribute('placement', 'top')
        this.$blockDetails.forEach(item => item.setAttribute('open', true))
      }
      this.$filtersDrawer?.show()
    })

    this.updateTotalFiltersCount()
    this.updateViewProductsCount()
    this.updateTotalProductsCount()

    this.$filtersDrawer.classList.remove('hidden')
  }

  _handleViewportChange = (newViewport) => {
    this.viewport = newViewport
    this._closeFilters()
  }

  _handleCheckboxChange = (event) => {
    this.updateSummaryFilterCount(event.target)
    this.updateTotalFiltersCount()

    this.debouncedOnSubmit(event)
  }

  updateSummaryFilterCount(currentFilter) {
    if (currentFilter === 'Clear All') {
      const $filterCountElements = document.querySelectorAll(
        '[data-filter-count]',
      )
      for (const $filterCountElement of $filterCountElements) {
        $filterCountElement.dataset.filterCount = 0
        $filterCountElement.innerHTML = ''
      }
      return
    }

    const optionType = currentFilter.dataset.optionType
    const $filterCountElements = document.querySelectorAll(
      `[data-filter-count][data-filter-option='${optionType}'`,
    )
    const filterCountValue = Number.parseInt(
      $filterCountElements[0].dataset.filterCount,
    )
    let newCountValue

    if (currentFilter.checked) {
      newCountValue = filterCountValue + 1
    } else {
      newCountValue = filterCountValue - 1
    }

    for (const $element of $filterCountElements) {
      $element.dataset.filterCount = newCountValue
      $element.innerHTML = newCountValue > 0 ? ` (${newCountValue})${t('sections.collection_template.selected')}` : ''
    }
  }

  updateTotalFiltersCount() {
    let filterCountSum = 0

    for (const $element of this.$summaryFilterCountEl) {
      filterCountSum += Number.parseInt($element.dataset.filterCount)
    }

    for (const $element of this.$totalFilterCountMarkers) {
      $element.innerHTML = filterCountSum > 0 ? ` (${filterCountSum})` : ''
    }

    this.$clearAll.classList[filterCountSum ? 'remove': 'add']('hidden')
  }

  _closeFilters = () => {
    this.$filtersDrawer?.hide()
  }

  _closeDetails(event) {
    const $detailsElements = this.querySelectorAll('.js-details-dropdown')
    for (const $element of $detailsElements) {
      if (!$element.contains(event.target)) {
        $element.open = false
      }
    }
  }

  onSubmitHandler = (event) => {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    for (const [key, value] of formData) {
    }
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, event)
  }

  clearFormValue(target) {
    const $targetedFilterValue =
      target.closest('.js-facet-remove').dataset.filterValue

    if ($targetedFilterValue) {
      const $form = target
        .closest('.js-collection-filters')
        .querySelector('.js-collection-filters__form')
      if ($targetedFilterValue === 'Clear All') {
        const $formItems = $form.querySelectorAll('sl-checkbox[checked]')
        for (const $formItem of $formItems) {
          $formItem.removeAttribute('checked')
        }
        this.updateSummaryFilterCount('Clear All')
        this.updateTotalFiltersCount()
      } else {
        const $formItem = $form.querySelector(
          `sl-checkbox[value="${$targetedFilterValue}"`,
        )
        $formItem.removeAttribute('checked')
        this.updateSummaryFilterCount($formItem)
        this.updateTotalFiltersCount()
      }
    }
  }

  _onActiveFilterClick = (event) => {
    event.preventDefault()
    this.toggleActiveFacets()
    this.clearFormValue(event.target)
    const formData = new FormData(
      event.target
        .closest('.collection-filters')
        .querySelector('.collection-filters__form'),
    )
    for (const [key, value] of formData) {
    }
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  _onHistoryChange = (event) => {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    const $removeFacets = document.querySelectorAll('.js-facet-remove')
    for (const $element of $removeFacets) {
      $element.classList.toggle('disabled', disable)
    }
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById('main-collection-product-grid')
      .querySelector('.js-product-grid')
      .classList.add('loading')

    const sections = this.getSections()
      .map((section) => `sections[]=${section.section}`)
      .join('&')

    const url = `${window.location.pathname}?${sections}&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('main-collection-product-grid').innerHTML
    const productGrid = document.getElementById('main-collection-product-grid')

    productGrid.innerHTML = innerHTML
    window.NovaProductCardV2?.initWithin(productGrid)

    this.updateViewProductsCount()
  }

  updateViewProductsCount() {
    const productGrid = document.getElementById('main-collection-product-grid')
    const productCards = productGrid.querySelectorAll('.js-product-card-v2')
    this.$viewProductsCountMarkers = document.querySelectorAll(
      '[data-view-products-count]',
    )

    this.$viewProductsCountMarkers.forEach(item => item.innerHTML = productCards.length)
  }

  updateTotalProductsCount() {
    const totalCount = Number(this.$filtersBar.querySelector('.js-showed-products-count').dataset.productsCount)
    this.$totalProductsCountMarkers.forEach(item =>
      item.innerHTML = totalCount
    )
    this.$totalProductsCountSurfix.innerHTML = totalCount === 1 ? t('sections.collection_template.item'): t('sections.collection_template.items')
  }

  renderFilters(...args) {
    this.renderSingleFormFilters('#CollectionFiltersForm', ...args)
  }

  updateActiveSort() {
    const activeSort = [...this.$sortInput.querySelectorAll('sl-radio')].find(item => item.value === this.$sortInput.value)
    this.querySelector('.js-sort-selected').innerHTML = activeSort.dataset.label
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const filtersBar = parsedHTML.querySelector('.js-filters-bar')
    if (filtersBar) {
      this.$filtersBar.innerHTML = filtersBar.innerHTML
    }

    const $facetDetailsElements = Array.from(
      parsedHTML.querySelectorAll(`${form} .js-filter`),
    )
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest('.js-filter')?.dataset.index

    const $facetsToRender = $facetDetailsElements.filter(
      (element) => !matchesIndex(element),
    )

    for (const $element of $facetsToRender) {
      document.querySelector(
        `${form} .js-filter[data-index="${$element.dataset.index}"]`,
      ).innerHTML = $element.innerHTML
    }

    this.renderActiveFacets(parsedHTML)
    this.updateViewProductsCount()
    this.updateTotalProductsCount()
    this.updateActiveSort()
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    for (const selector of activeFacetElementSelectors) {
      const $activeFacetsElement = html.querySelector(selector)
      if (!$activeFacetsElement) return
      document.querySelector(selector).innerHTML =
        $activeFacetsElement.innerHTML
    }

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  bindActiveFacetButtonEvents() {
    const $removeFacets = document.querySelectorAll('.js-facet-remove')
    for (const $element of $removeFacets) {
      $element.addEventListener('click', this._onActiveFilterClick, {
        once: true,
      })
    }
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-filters',
        section: document.getElementById('main-collection-filters').dataset.id,
      },
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }
}

customElements.define('nova-filters-wrapper', NovaFiltersWrapper)
